import { createClient, SupabaseClient } from '@supabase/supabase-js';

let portalSupabaseInstance: SupabaseClient | null = null;
let initPromise: Promise<SupabaseClient> | null = null;

export async function getPortalSupabase(): Promise<SupabaseClient> {
  if (portalSupabaseInstance) {
    return portalSupabaseInstance;
  }

  if (!initPromise) {
    initPromise = fetch('/api/config')
      .then((r) => r.json())
      .then(({ url, anonKey }) => {
        portalSupabaseInstance = createClient(url, anonKey, {
          auth: {
            autoRefreshToken: true,
            persistSession: true,
            // true: auto-processes hash tokens (#access_token=...) on fresh page loads.
            // PortalCallback also handles all cases explicitly as a fallback.
            detectSessionInUrl: true,
            storageKey: 'portal-auth', // separate from staff app session
          },
        });
        return portalSupabaseInstance;
      });
  }

  return initPromise;
}
